import React from 'react';
import Logo from 'assets/images/logo.png';
import { Link } from 'react-router-dom';
import { getZoom } from 'shared/utils/appHelpers';
import useWindowSizes from 'shared/hooks/useWindowSizes';

const AuthLayout = ({ children }) => {
  const [width] = useWindowSizes();

  return (
    <div
      style={{ zoom: getZoom(width) }}
      className='auth-pages d-flex justify-content-center flex-column align-items-center py-10 py-md-20 px-8'
    >
      <div className='content d-flex flex-column justify-content-between align-items-center flex-fill w-100'>
        <Link to='/' className='mb-10 mb-md-20'>
          <img src={Logo} className='logo' alt='Logo' title='Logo' />
        </Link>
        {children}
        <div />
      </div>
    </div>
  );
};

export default AuthLayout;
